import FileSaver from 'file-saver';

function escapeCell(value) {
  if (value === null || value === undefined) return '';
  const str = String(value);
  if (/[",\r\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

function buildCsv(headers, rows) {
  const lines = [headers.map(escapeCell).join(',')];
  for (let i = 0; i < rows.length; i++) {
    lines.push(rows[i].map(escapeCell).join(','));
  }
  return `﻿${lines.join('\r\n')}`;
}

function formatDate(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toISOString();
}

export function exportTranslationsToCsv({
  translations,
  selectedLanguages,
  includeList = false,
  fileName,
}) {
  const headers = [];
  if (includeList) headers.push('List name');
  headers.push('Translation key');
  headers.push('Default value');
  for (let i = 0; i < selectedLanguages.length; i++) {
    headers.push(`Value (${selectedLanguages[i]})`);
  }

  const rows = translations.map(item => {
    const row = [];
    if (includeList) row.push(item.list || '');
    row.push(item.key || '');
    row.push(item.defaultValue || '');
    for (let i = 0; i < selectedLanguages.length; i++) {
      const t = item[selectedLanguages[i]] || {};
      row.push(t.value || t.inherited || '');
    }
    return row;
  });

  const csv = buildCsv(headers, rows);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  FileSaver.saveAs(blob, fileName);
}
